export const currentCustomer = (state) => state.currentCustomer;